import { render, staticRenderFns } from "./ViewLogistics.vue?vue&type=template&id=04c12018&scoped=true"
import script from "./ViewLogistics.vue?vue&type=script&lang=js"
export * from "./ViewLogistics.vue?vue&type=script&lang=js"
import style0 from "./ViewLogistics.vue?vue&type=style&index=0&id=04c12018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c12018",
  null
  
)

export default component.exports